/**
 * Wallet Pass Service
 * Issues and serves Apple Wallet and Google Wallet loyalty passes for Convercus programs. Internal administrators register programs, mint program API keys, maintain store locations, configure wallet design and levels, read adoption analytics and query the audit trail; customer-facing clients download a pass through the program-scoped download routes, and the wallets themselves keep it current through the Apple PassKit web service and the Google Wallet Objects callback. Every path below already carries the gateway base prefix `/wallet-pass-service`.
 *
 * The version of the OpenAPI document: 1.0.39938
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WalletCtasLevelOverrideDto } from './wallet-ctas-level-override-dto';


export interface LevelItemDto { 
    balanceName?: object | null;
    backgroundColor?: object | null;
    foregroundColor?: object | null;
    icon?: object | null;
    passLogo?: object | null;
    bannerImage?: object | null;
    /**
     * Per-slot CTA override. Omit to inherit Design for both platforms. For each platform, omit a slot key to inherit, pass null to hide that slot, or pass an object to override it (hidden: true keeps the config without showing it). Arrays are accepted as a full-platform replace. PUT replaces the whole override (same as other level fields).
     */
    ctas?: WalletCtasLevelOverrideDto | null;
    key: string;
    origin: LevelItemDto.OriginEnum;
}
export namespace LevelItemDto {
    export type OriginEnum = 'catalog' | 'override' | 'both';
    export const OriginEnum = {
        Catalog: 'catalog' as OriginEnum,
        Override: 'override' as OriginEnum,
        Both: 'both' as OriginEnum
    };
}


